<template>
  <b-modal :visible="visible" no-close-on-backdrop no-close-on-esc centered body-class="insurance-list-body">
    <div slot="modal-header" class="w-100">
      <h5>Select Insurances
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <div>
      <b-form-group>
        <b-form-radio-group v-model="filterByInsurance"
                            :options="filterOptions"
                            stacked
                            name="filterOption">
        </b-form-radio-group>
      </b-form-group>
      <transition name="slide">
        <b-form-group v-show="filterByInsurance">
          <b-form-checkbox
              v-model="allSelected"
              @change="toggleAll"
          >
            {{ allSelected ? 'Un-select All' : 'Select All' }}
          </b-form-checkbox>
          <b-form-checkbox
              v-for="company in sortedInsuranceCompanies" :key="company.organizationInsuranceCompanyId"
              class="ml-4"
              stacked
              :id="'insurance-' + company.organizationInsuranceCompanyId"
              v-model="insuranceIds"
              :value="company.organizationInsuranceCompanyId"
             > {{ company.name }}
          </b-form-checkbox>
        </b-form-group>
      </transition>
      </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="saveInsuranceIds()">Save</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'insurance-select',

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      selectedInsuranceIds: {
        type: Array,
        required: true
      },

      orgInsuranceCompanies: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        insuranceIds: _.clone(this.selectedInsuranceIds),
        insuranceCompanies: _.clone(this.orgInsuranceCompanies),
        allSelected: false,
        filterByInsurance: this.selectedInsuranceIds.length > 0,
        filterOptions: [
          { text: 'All Insurances', value: false },
          { text: 'Select Insurances', value: true }
        ]

      }
    },

    watch: {
      selectedInsuranceIds (newValue) {
        this.insuranceIds = _.clone(newValue)
        if (newValue.length === 0) {
          this.allSelected = false
        } else if (newValue === this.allInsuranceIds) {
          this.allSelected = true
        } else {
          this.allSelected = false
        }
      }
    },

    computed: {
      sortedInsuranceCompanies () {
        if (this.$props.orgInsuranceCompanies && this.$props.orgInsuranceCompanies.length > 0) {
          const companies = this.$props.orgInsuranceCompanies
          return companies.sort((lhs, rhs) => {
            return (lhs.name > rhs.name) ? 1 : ((rhs.name > lhs.name) ? -1 : 0)
          })
        }

        return []
      },
      allInsuranceIds () {
        return this.sortedInsuranceCompanies.map(aSortedInsuranceCompany => {
          return aSortedInsuranceCompany.organizationInsuranceCompanyId
        })
      }
    },

    methods: {
      toggleAll (checked) {
        this.insuranceIds = checked ? this.allInsuranceIds : []
      },
      saveInsuranceIds () {
        if (this.filterByInsurance) {
          this.$emit('saveInsuranceIds', this.insuranceIds)
        } else {
          this.insuranceIds = []
          this.$emit('saveInsuranceIds', [])
        }
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
